import React, { Component } from 'react'
// redux
import { WrappedFieldProps } from 'redux-form'
// types
import { RadioPropsType } from 'components/Form/Fields/FieldRadio'
// styles
import { sheet } from './sheet'
import injectSheet, { StyledComponentProps } from 'react-jss'

const CheckedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="8" fill="#091E42" fillOpacity="0.13" />
    <rect width="16" height="16" fill="white" fillOpacity="0.01" />
    <circle cx="8" cy="8" r="8" fill="#286EFA" />
    <circle cx="8.00007" cy="8.00007" r="2.28571" fill="white" />
  </svg>
)

const UncheckedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#94A3B8" />
  </svg>
)

type Props = RadioPropsType &
  React.InputHTMLAttributes<HTMLInputElement> &
  WrappedFieldProps &
  StyledComponentProps

class Radio extends Component<Props> {
  render() {
    const { input, name, label, id, classes = {}, disabled = false, ...arg } = this.props
    const isChecked = input && input.checked
    return (
      <div className={classes.root}>
        <input
          type="radio"
          name={name}
          id={id}
          {...input}
          className={classes.radio}
          disabled={disabled}
          {...arg}
        />
        <label htmlFor={id}>
          <div className={classes.iconSize}>
            {isChecked ? <CheckedIcon /> : <UncheckedIcon />}
          </div>
          {label}
        </label>
      </div>
    )
  }
}

export default injectSheet(sheet)(Radio)
